'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (val, fieldName, fieldValue) {
  var value = (0, _cloneDeep2.default)(val);
  var keyParts = fieldName.split('.');

  setValue(value, keyParts, fieldValue);

  return value;
};

var _cloneDeep = require('lodash/cloneDeep');

var _cloneDeep2 = _interopRequireDefault(_cloneDeep);

var _isPlainObject = require('lodash/isPlainObject');

var _isPlainObject2 = _interopRequireDefault(_isPlainObject);

var _isNil = require('lodash/isNil');

var _isNil2 = _interopRequireDefault(_isNil);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var setValue = function setValue(value, keyParts, fieldValue) {
  var key = keyParts.shift();
  if (keyParts.length === 0) {
    value[key] = fieldValue;
  } else {
    if (!isNaN(keyParts[0])) {
      // next key is array
      if ((0, _isNil2.default)(value[key])) {
        value[key] = [];
      }
    } else {
      if ((0, _isNil2.default)(value[key])) {
        value[key] = {};
      }
      if (!(0, _isPlainObject2.default)(value[key])) {
        throw new Error('Expected plain object for key ' + key);
      }
    }
    setValue(value[key], keyParts, fieldValue);
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/simple-react-form/lib/Form/getNewValue.js
// module id = 983
// module chunks = 21